// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#select {
    display: flex;
    align-items: center;
}
.headset-icon{
    cursor: pointer;
    width: 20px;
    height: 20px;
    margin-right: 4px;
    margin-top: -2px;
    color: var(--color-primary);
    opacity: 0.9;
}`, "",{"version":3,"sources":["webpack://./src/layouts/SidebarLayout/Header/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,YAAY;AAChB","sourcesContent":["#select {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n.headset-icon{\r\n    cursor: pointer;\r\n    width: 20px;\r\n    height: 20px;\r\n    margin-right: 4px;\r\n    margin-top: -2px;\r\n    color: var(--color-primary);\r\n    opacity: 0.9;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
